import { render, staticRenderFns } from "./SearchSelect.vue?vue&type=template&id=045d668c&scoped=true"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchSelect.vue?vue&type=style&index=0&id=045d668c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d668c",
  null
  
)

export default component.exports